import React from 'react';
import i18n from '../../../i18n';
import {withFormik} from 'formik';
import axios from 'axios';
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import FormField from "../../Form/FormField";
import FormDate from "../../Form/FormDate";
import Grid from "@material-ui/core/Grid/Grid";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {Hidden, withStyles} from "@material-ui/core";
import {mergeWithDefault} from "../../Form/utils";
import FormCheck from "../../Form/FormCheck";
import swal from "sweetalert";
import FormAutocomplete from "../../Form/FormAutocomplete";
import {array, object, string} from "yup";
import DeleteButton from "../../Form/DeleteButton";
import FormSelect from "../../Form/FormSelect";
import Divider from '@material-ui/core/Divider';
import MediaDropButton from '../../Media/DropButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from "@material-ui/core/Typography";
import SignatureCanvas from 'react-signature-canvas';
import FormRadio from "../../Form/FormRadio";

class ShelvingSystems extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showCompany: false,
            signatureData1: '',
            signatureData2: '',
            updatingFields: false,
        };
    }

    sigCanvas1 = {}
    sigCanvas2 = {}

    handleSign1 = () => {
        this.setState({signatureData1: this.sigCanvas1.toDataURL()});
    }
    handleSign2 = () => {
        this.setState({signatureData2: this.sigCanvas2.toDataURL()});
    }

    render() {
        const {
            classes,
            values,
            protocol,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            formUrl,
            customer,
            structure,
            uploadConfig,
        } = this.props;

        values.signature1 = this.state.signatureData1
        values.signature2 = this.state.signatureData2
        if(protocol && protocol.is_correction) {
            values.is_correction = true;
            values.from_protocol_id = protocol.id;
        }

        return (
            <React.Fragment>
                <Grid item>
                    <Grid container spacing={16} alignItems="center">
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="producer"
                                label='Hersteller:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.producer}
                                inputProps={{
                                    maxLength : 25
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="type"
                                label='Typ:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type}
                                inputProps={{
                                    maxLength : 25
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="number"
                                name="construction_year"
                                label='Baujahr:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.construction_year}
                                inputProps={{
                                    max : 2100
                                }}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="address"
                                label='Adresse:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.address}
                                inputProps={{
                                    maxLength : 25
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>&nbsp;</Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="security_officer"
                                label='Sicherheitsbeauftragter:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.security_officer}
                                inputProps={{
                                    maxLength : 25
                                }}
                            />
                        </Grid>
                        <Grid item xs={8}>&nbsp;</Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="security_officer_contact"
                                label='Telefon/E-Mail:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.security_officer_contact}
                                inputProps={{
                                    maxLength : 40
                                }}
                            />
                        </Grid>

                        <Grid item xs={2}>
                            <Typography component={"div"}
                                        variant={"body1"}>
                                <b><u>Bauart:</u></b>
                            </Typography>
                        </Grid>
                        <Grid item xs={10}>
                            <Grid container>
                                <Grid item xl={3} sm={6} xs={12}>
                                    <FormCheck
                                        name="shelf1"
                                        label='Palettenregal'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.shelf1}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={6} xs={12}>
                                    <FormCheck
                                        name="shelf2"
                                        label='Fachbodenregal'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.shelf2}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={6} xs={12}>
                                    <FormCheck
                                        name="shelf3"
                                        label='Einfahrregal'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.shelf3}
                                    />
                                </Grid>
                                <Grid item xl={3} sm={6} xs={12}>
                                    <FormCheck
                                        name="shelf4"
                                        label='Durchlaufregal'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.shelf4}
                                    />
                                </Grid>
                                <Grid item xl={3} md={6} xs={12}>
                                    <FormCheck
                                        name="shelf5"
                                        label='Kragarmregal'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.shelf5}
                                    />
                                </Grid>
                                <Grid item xl={3} md={6} xs={12}>
                                    <FormCheck
                                        name="shelf6"
                                        label='Mehrgeschoßregal'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.shelf6}
                                    />
                                </Grid>
                                <Grid item xl={3} md={6} xs={12}>
                                    <FormCheck
                                        name="shelf7"
                                        label='Durchfahrregal'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.shelf7}
                                    />
                                </Grid>
                                <Grid item xl={3} md={6} xs={12}>
                                    <FormCheck
                                        name="shelf8"
                                        label='mech. verfahrbares Regal'
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.shelf8}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="shelf_number"
                                label='Regalnummer:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.shelf_number}
                                inputProps={{
                                    maxLength : 25
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="location"
                                label='Standort:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.location}
                                inputProps={{
                                    maxLength : 25
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="dimension"
                                label='Abmessungen:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.dimension}
                                inputProps={{
                                    maxLength : 25
                                }}
                            />
                        </Grid>

                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="shelf_height"
                                label='Fachhöhe:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.shelf_height}
                                inputProps={{
                                    maxLength : 25
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="fields"
                                label='Böden/Feld:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.fields}
                                inputProps={{
                                    maxLength : 25
                                }}
                            />
                        </Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="field_count"
                                label='Feldanzahl:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.field_count}
                                inputProps={{
                                    maxLength : 25
                                }}
                            />
                        </Grid>

                        <Grid item xs={8}>&nbsp;</Grid>
                        <Grid item xs={4}>
                            <FormField
                                type="text"
                                name="pallet_spaces"
                                label='Palettenplätze pro Regalfach:'
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.pallet_spaces}
                                inputProps={{
                                    maxLength : 25
                                }}
                            />
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                </Grid>

                <Table width="90% !important">
                    <TableHead>
                        <TableRow>
                            <TableCell width="30%">
                                &nbsp;
                            </TableCell>
                            <TableCell width="40%">
                            </TableCell>
                            <TableCell width="10%">
                                Gefahrenstufe
                            </TableCell>
                            <TableCell width="20%">
                                erforderliche Maßnahmen
                            </TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        1. Schutzmaßnahmen:
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Sicherung gegen Durchfallen
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="falling_through"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.falling_through || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="falling_through_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.falling_through_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="falling_through_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.falling_through_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Sicherung gegen Herabfallen
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="falling_down"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.falling_down || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="falling_down_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.falling_down_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="falling_down_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.falling_down_measures}
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        2. Anfahrschutz:
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Anfahrschutz vorhanden
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="collision_protection"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.collision_protection || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="collision_protection_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.collision_protection_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="collision_protection_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.collision_protection_measures}
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        3. Beschädigungen an Bauteilen:
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Verankerung
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="anchoring"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.anchoring || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="anchoring_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.anchoring_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="anchoring_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.anchoring_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Ständer/Stützen
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="uprights"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.uprights || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="uprights_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.uprights_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="uprights_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.uprights_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Fachwerk
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="truss"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.truss || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="truss_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.truss_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="truss_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.truss_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Träger
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="carrier"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.carrier || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="carrier_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.carrier_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="carrier_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.carrier_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Fachböden
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="shelves"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.shelves || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="shelves_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.shelves_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="shelves_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.shelves_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Kragarme
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="cantilevers"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.cantilevers || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="cantilevers_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.cantilevers_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="cantilevers_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.cantilevers_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                sonstige Bauteile
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="other_parts"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.other_parts || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="other_parts_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.other_parts_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="other_parts_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.other_parts_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Beschädigungen durch Bohren, Schweißen, Anbauten
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="damages"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.damages || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="damages_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.damages_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="damages_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.damages_measures}
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        4. Bedienung der Regale:
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Belastungsschilder aktuell und konform
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="load_tags"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.load_tags || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="load_tags_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.load_tags_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="load_tags_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.load_tags_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                zulässige Ladungsträger verwendet
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="load_carriers"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.load_carriers || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="load_carriers_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.load_carriers_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="load_carriers_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.load_carriers_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                ordnungsgemäße Einlagerung
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="proper_storage"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.proper_storage || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="proper_storage_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.proper_storage_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="proper_storage_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.proper_storage_measures}
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        5. Regalzustand gemäß Spezifikation:
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Sicherungsstifte angebracht
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="safety_pins"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.safety_pins || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="safety_pins_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.safety_pins_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="safety_pins_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.safety_pins_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                fester Stand der Regale, lotrechter Stand
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="vertical_stand"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.vertical_stand || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="vertical_stand_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.vertical_stand_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="vertical_stand_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.vertical_stand_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Verbände
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="units"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.units || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="units_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.units_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="units_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.units_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Verankerung, Unterfütterung der Ständer
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="relining"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.relining || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="relining_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.relining_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="relining_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.relining_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Fachhöhen
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="shelf_heights"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.shelf_heights || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="shelf_heights_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.shelf_heights_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="shelf_heights_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.shelf_heights_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Anzahl der Fachebenen
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="level_numbers"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.level_numbers || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="level_numbers_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.level_numbers_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="level_numbers_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.level_numbers_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Kragarme
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="conditions_canteliver"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.conditions_canteliver || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="conditions_canteliver_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.conditions_canteliver_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="conditions_canteliver_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.conditions_canteliver_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Verwendung zugelassener Bauteile
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="approved_components"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.approved_components || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="approved_components_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.approved_components_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="approved_components_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.approved_components_measures}
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        6. Mehrfachgeschossanlagen:
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Zustand der Palettenübergabeplätze
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="pallet_transfer_stations"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.pallet_transfer_stations || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="pallet_transfer_stations_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.pallet_transfer_stations_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="pallet_transfer_stations_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.pallet_transfer_stations_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Zustand des Gang-/Bühnenbodens (Befestigung)
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="aisle_floor"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.aisle_floor || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="aisle_floor_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.aisle_floor_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="aisle_floor_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.aisle_floor_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Zustand der Treppen/Geländer
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="stairs"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.stairs || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="stairs_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.stairs_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="stairs_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.stairs_measures}
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        7. Einfahr- und Durchfahrregale:
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Hinweis Zertifikat
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="note_certificate"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.note_certificate || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="note_certificate_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.note_certificate_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="note_certificate_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.note_certificate_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                korrekte Einlagerung
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="correct_storage"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.correct_storage || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="correct_storage_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.correct_storage_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="correct_storage_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.correct_storage_measures}
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell>
                                <b>
                                    <u>
                                        8. Dokumentationen liegen vor:
                                    </u>
                                </b>
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                            <TableCell>
                                &nbsp;
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Bedienungsanleitung/Handbuch
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="manual"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.manual || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="manual_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.manual_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="manual_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.manual_measures}
                                />
                            </TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell>
                                Protokolle der regelmäßigen Sichtprüfung
                            </TableCell>
                            <TableCell>
                                <FormRadio
                                    name="visual_inspection"
                                    options={[
                                        {
                                            value : 'okay',
                                            label : 'i.O.'
                                        },
                                        {
                                            value : 'not_okay',
                                            label : 'n.i.O.'
                                        },
                                        {
                                            value : 'not_applicable',
                                            label : 'nicht zutreffend'
                                        }
                                    ]}
                                    onChange={handleChange}
                                    className={classes.formRadio}
                                    classNameRadio={classes.formSelection}
                                    onBlur={handleBlur}
                                    value={values.visual_inspection || ''}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="visual_inspection_security_level"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.visual_inspection_security_level}
                                />
                            </TableCell>
                            <TableCell>
                                <FormField
                                    type="text"
                                    name="visual_inspection_measures"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.visual_inspection_measures}
                                />
                            </TableCell>
                        </TableRow>

                        <TableRow>
                            <TableCell colSpan={4}>
                                <Grid item xs={12}>
                                    <FormField
                                        type="text"
                                        name="notations"
                                        label='Bemerkungen:'
                                        multiline
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.notations}
                                    />
                                </Grid>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>

                <Grid item xs={12}>
                    <FormRadio
                        name="inspection_tag"
                        options={[
                            {
                                value : 'yes',
                                label : 'Prüfplakette erteilt',
                            },
                            {
                                value : 'no',
                                label : 'Prüfplakette nicht erteilt',
                            }
                        ]}
                        onChange={handleChange}
                        className={classes.formRadio}
                        classNameRadio={classes.formButton}
                        onBlur={handleBlur}
                        value={values.inspection_tag}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Datum:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="current_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.current_date}
                    />
                </Grid>
                <Hidden smDown>
                    <Grid item xs={1}>&nbsp;</Grid>
                </Hidden>
                <Grid item xs={2}>
                    <Typography component={"div"}
                                variant={"body2"}>
                        Nächster Prüftermin:
                    </Typography>
                </Grid>
                <Grid item md={3} sm={4} justify="center">
                    <FormDate
                        type="date"
                        name="next_date"
                        // label={i18n.get('cooperations.day_last_appointment')}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.next_date}
                    />
                </Grid>

                <Hidden smDown>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas1 = ref }}
                                    onEnd={this.handleSign1}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={1}>&nbsp;</Grid>
                            <Grid item xs={10} style={{ border: '1px solid black' }}>
                                <SignatureCanvas
                                    penColor='black'
                                    canvasProps={{width: 500, height: 200}}
                                    ref={(ref) => { this.sigCanvas2 = ref }}
                                    onEnd={this.handleSign2}
                                />
                            </Grid>
                            <Grid item xs={1}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Auftraggeber
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={6}>
                        <Grid container xs={12} spacing={24} justify="center" alignItems="center">
                            <Grid item xs={3}>&nbsp;</Grid>
                            <Grid item xs={6} style={{ textAlign: "right" }}>
                                <Typography component={"div"}
                                            variant={"body1"}>
                                    Unterschrift Prüfer
                                </Typography>
                            </Grid>
                            <Grid item xs={3}>&nbsp;</Grid>
                        </Grid>
                    </Grid>
                </Hidden>

                <Hidden mdUp>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas1 = ref }}
                            onEnd={this.handleSign1}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Auftraggeber
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>&nbsp;</Grid>
                    <Grid item xs={12} style={{ border: '1px solid black' }}>
                        <SignatureCanvas
                            penColor='black'
                            canvasProps={{width: 500, height: 200}}
                            ref={(ref) => { this.sigCanvas2 = ref }}
                            onEnd={this.handleSign2}
                        />
                    </Grid>
                    <Grid item xs={12} style={{ textAlign: "center" }}>
                        <Typography component={"div"}
                                    variant={"body1"}>
                            Unterschrift Prüfer
                        </Typography>
                    </Grid>
                </Hidden>
            </React.Fragment>
        )
    }
}

const styles = theme => ({
    deleteButton: {
        // background: theme.colors.error
    },
    textLeft: {
        textAlign: "left",
    },
    textCenter: {
        textAlign: "center",
    },
    textRight: {
        textAlign: "right",
    },
    formRadio: {
        flexDirection: "row",
        marginLeft: '100px'
    },
    formButton: {
    },
    formSelection: {
    },
});

export default withStyles(styles)(ShelvingSystems)



// WEBPACK FOOTER //
// ./resources/assets/js/components/Protocols/Protocols/ShelvingSystems.js